import { defineStore } from 'pinia'
import { STORE } from '~/constants/strings'
import type {
  IFeatureFlag,
  TFeatureFlagKey,
} from '~/constants/types/featureFlags'
import { FEATURE_FLAG } from '~/constants/types/featureFlags'
import { getStoreKey } from '~/helpers/store'

export const useFeatureFlagsStore = defineStore(
  STORE.FEATURE_FLAGS,
  () => {
    const flags = ref<Partial<Record<TFeatureFlagKey, boolean>>>({})

    const featureFlagsList: IFeatureFlag[] = [
      {
        key: FEATURE_FLAG.AUDIT_CENTER,
        enabled: false,
        description: 'Enable Audit Center functionality',
      },
      // {
      //   key: FEATURE_FLAG.GOOD_FAITH_EFFORTS,
      //   enabled: false,
      //   description: 'Enable Good Faith Efforts tracking and reporting',
      // },
      {
        key: FEATURE_FLAG.ACTION_ORIENTED_PROGRAMS,
        enabled: false,
        description: 'Enable Action-Oriented Programs management',
      },
      // {
      //   key: FEATURE_FLAG.COMPLIANCE_CHECKLIST,
      //   enabled: false,
      //   description: 'Enable Compliance Checklist functionality',
      // },

      // {
      //   key: FEATURE_FLAG.EXECUTIVE_SUMMARY,
      //   enabled: false,
      //   description: 'Enable WFA Executive Summay',
      // },
    ]

    const initializeFeatureFlags = () => {
      const defaultFlags = featureFlagsList.reduce(
        (acc, flag) => ({
          ...acc,
          [flag.key]: flag.enabled,
        }),
        {} as { [key in TFeatureFlagKey]: boolean }
      )

      flags.value = {
        ...defaultFlags,
        ...flags.value, // Keep existing persisted values
      }
    }

    const setFeatureFlag = (key: TFeatureFlagKey, enabled: boolean) => {
      flags.value = {
        ...flags.value,
        [key]: enabled,
      }
    }

    const isFeatureEnabled = (key: TFeatureFlagKey): boolean => {
      return Boolean(flags.value[key] || window.__env?.[key])
    }

    const resetFeatureFlags = () => {
      flags.value = {}
    }

    return {
      flags,
      featureFlagsList,
      initializeFeatureFlags,
      setFeatureFlag,
      isFeatureEnabled,
      resetFeatureFlags,
    }
  },
  {
    persist: {
      pick: ['flags'],
      key: getStoreKey(STORE.FEATURE_FLAGS),
    },
  }
)
